<template>
  <div class="connection-status-badge">
    <el-button
      v-if="connectionStatus === 'RECONNECTING'"
      type="danger"
      round
      size="small"
      title="Utracono połączenie z serwerem. Automatycznie probujemy Cię znów podłączyć!"
    >
      Reconnecting...
    </el-button>

    <el-button
      v-if="connectionStatus === 'CONNECTED'"
      type="success"
      round
      size="small"
      title="Jesteś podłączony do serwera, dane będą się same aktualizować bez potrzeby odświeżania!"
    >
      Connected
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'ConnectionStatusBadge',
  computed: {
    connectionStatus() {
      return this.$store.state.connectionStatus
    }
  }
}
</script>

<style scoped>
.connection-status-badge {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
